import { isRouteApplication, isRouteHome } from '@/router/checkRoutes';

// Решения beforeEach о доступе, вынесенные из router/index.js в чистые функции, чтобы их можно было тестировать.

interface RouteLike {
  name?: string | null;
  path: string;
  fullPath?: string;
}

export interface UserAccess {
  checkRoute: (route: string) => boolean;
  role?: { defaultPage?: number | null };
  menuFlat: { id: number; url?: string }[];
}

/**
 * Куда перенаправить авторизованного пользователя; null - пускать на страницу (дальше middleware).
 * Страница доступна, если её адрес есть в меню роли. Карточка заявки - если в меню есть список заявок.
 * При входе на главную (первая загрузка или сразу после логина) - на страницу роли по умолчанию.
 */
export function getAuthorizedRedirect(to: RouteLike, from: RouteLike, user: UserAccess): string | null {
  const toName = to.name ?? '';
  const isHome = isRouteHome(toName);

  if (!isHome && !user.checkRoute(to.path) && !(isRouteApplication(toName) && user.checkRoute('/bank/applications'))) {
    return '/';
  }

  if (isHome && (from.name === null || from.name === 'Login')) {
    const defaultPageId = user.role?.defaultPage;
    if (defaultPageId) {
      const defaultMenuItem = user.menuFlat.find((item) => item.id === defaultPageId);
      if (defaultMenuItem?.url) {
        return defaultMenuItem.url;
      }
    }
  }

  return null;
}

/** Куда перенаправить неавторизованного пользователя; null - пускать (страница входа). */
export function getUnauthorizedRedirect(to: RouteLike) {
  if (to.name === 'Login') {
    return null;
  }
  return { name: 'Login', params: { nextUrl: to.fullPath }, replace: true };
}
